import { Icon } from "@/components/common/Icon";
import { isProviderAccessNoticeKind, type NoticeKind } from "@/lib/chat";

interface SystemNoticeCardProps {
	noticeKind: NoticeKind;
	/** backend が確定させた日本語の通知文言。そのまま表示する。 */
	text: string;
}

const ACCESS_TITLES: Partial<Record<NoticeKind, string>> = {
	creditExhausted: "組織のクレジットが不足しています",
	deviceRevoked: "デバイスが失効しています",
	deviceUnauthenticated: "デバイスの認証が切れています",
	ipNotAllowed: "接続元が許可されていません",
};

/**
 * ユーザーに可視化するシステム通知カード。既定は SystemError の赤いカードに対するニュートラル版で、
 * 自動要約の失敗やコンテキスト上限到達など「エラーではないが知らせたい」状況に使う。
 * gateway のアクセス拒否 (利用再開にユーザー操作が要る) は見出し付きの警告トーンで表示する。
 */
export function SystemNoticeCard({ noticeKind, text }: SystemNoticeCardProps) {
	if (isProviderAccessNoticeKind(noticeKind)) {
		return (
			<div data-testid="system-notice" data-notice-kind={noticeKind} style={{ padding: "8px 0" }}>
				<div
					className="select-text"
					style={{
						borderRadius: "var(--radius-4)",
						border: "1px solid var(--warning-line)",
						background: "var(--warning-subtle)",
						padding: 12,
						fontSize: "var(--text-ui)",
						lineHeight: "var(--leading-body)",
					}}
				>
					<div style={{ display: "flex", alignItems: "center", gap: 8, color: "var(--warning)" }}>
						<Icon name="alertTriangle" size={16} color="var(--warning)" />
						<strong>{ACCESS_TITLES[noticeKind]}</strong>
					</div>
					<p
						className="whitespace-pre-wrap wrap-anywhere"
						style={{ margin: "6px 0 0 24px", color: "var(--fg-2)" }}
					>
						{text}
					</p>
				</div>
			</div>
		);
	}

	return (
		<div data-testid="system-notice" data-notice-kind={noticeKind} style={{ padding: "8px 0" }}>
			<div
				className="select-text"
				style={{
					display: "flex",
					gap: 8,
					borderRadius: "var(--radius-4)",
					border: "1px solid var(--line-1)",
					background: "var(--surface-2)",
					padding: "10px 12px",
					fontSize: "var(--text-ui)",
					lineHeight: "var(--leading-body)",
					color: "var(--fg-2)",
				}}
			>
				<span style={{ flexShrink: 0 }}>ⓘ</span>
				<p className="whitespace-pre-wrap wrap-anywhere my-0">{text}</p>
			</div>
		</div>
	);
}
